/* eslint-disable no-undef */
const { io } = require('socket.io-client');

const BASE_URL = process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://localhost:3000';

let _socket = null;

function connectSocket() {
    const token = localStorage.getItem('auth');
    if (!token) return null;
    if (_socket && _socket.connected) return _socket;

    _socket = io(BASE_URL, {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 2000,
        reconnectionAttempts: 10,
    });

    _socket.on('connect_error', () => {
    });

    return _socket;
}

function getSocket() { return _socket; }

function disconnectSocket() {
    if (_socket) {
        _socket.disconnect();
        _socket = null;
    }
}

module.exports = { connectSocket, getSocket, disconnectSocket };
